import { render, staticRenderFns } from "./distributionsRules.vue?vue&type=template&id=4ac3197e&scoped=true&"
import script from "./distributionsRules.vue?vue&type=script&lang=js&"
export * from "./distributionsRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac3197e",
  null
  
)

export default component.exports